<template>
  <div class="dealers" v-if="dealers">
    <template v-if="!popupEdit || !isMobile">
      <h1 class="dealers__title">Дилеры</h1>
      <FilterPage
        class="dealers__head"
        @setDiscounts="setDiscounts"
        @changeManagerOrders="changeManagerOrders"
        @changeEmails="changeEmails"
        @updateFilter="updateFilter"
        @clearFilters="clearFilters"
        :isOrdersFilterActions="dealers.length > 0"
        :filters="filters"
        :selectOrders="selectOrders"
        :cityOptions="cityOptions"
        :managerOptions="managerOptions"
      />

      <Application
        v-for="(dealer, index) in notApprovedDealers"
        :key="index"
        :dealer="dealer"
        :index="index"
        :dealerData="dealerData"
        @updateApprovedDealers="pullNotApprovedDealers"
        @updateSubDealers="updateSubDealers"
        @popupEditToggle="popupEditToggle"
      />

      <List
        @updateSelectOrders="updateSelectOrders"
        @updateAllSelected="updateAllSelected"
        @changeManager="changeManager"
        @clickDiscount="clickDiscount"
        @popupEditToggle="popupEditToggle"
        @updateFilter="updateFilter"
        @updateSort="updateSort"
        @popupDealerDeleteOpen="popupDealerDeleteOpen"
        :list="dealersSort"
        :selectOrders="selectOrders"
        :dealerData="dealerData"
        :filters="filters"
        :sort="sort"
      />

      <div class="dealers__result">
        <div>
          <span>Итого:</span>
        </div>
        <div>Дилеров: {{ dealers.length }}</div>
        <div>Сотрудников: {{ dealersCount('employees_count') }}</div>
        <div>Субдилеров: {{ dealersCount('sub_dealers_count') }}</div>
      </div>
    </template>

    <Edit
      v-if="popupEdit"
      @popupToggle="popupEditToggle"
      @success="successEdit"
      @clickDiscount="clickDiscount"
      :dealerData="dealerData"
    />

    <PopupChangeManager
      @close="popupChangeManagerClose"
      :isOpen="isPopupChangeManager"
      :uuidList="popupChangeManagerOrders"
      :item="popupChangeManagerOrder"
      :items="dealersSort"
      @closeSave="popupCloseSave"
    />

    <PopupChangeEmails
      :isOpen="isPopupChangeEmails"
      :uuidList="selectOrders"
      @close="changeEmailsClose"
      @closeSave="popupCloseSave"
    />

    <PopupDealerDiscount
      @close="popupDealerDiscountClose"
      :isOpen="isPopupDealerDiscount"
      :uuidList="selectOrders"
      :item="popupDealerDiscountItem"
      :items="dealersSort"
      @closeSave="popupCloseSave"
    />

    <transition name="fade">
      <PopupDealerDelete
        v-if="popupDealerDelete"
        @close="popupDealerDeleteClose"
        @success="popupDealerDeleteSuccess"
        :dealerDelete="popupDealerDelete"
      />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'AccountDealers',

  components: {
    Application: () => import('./components/Application'),
    List: () => import('./components/list/List'),
    Edit: () => import('./components/Edit/Edit'),
    FilterPage: () => import('./components/filter-page/FilterPage.vue'),
    PopupChangeManager: () => import('./components/PopupChangeManager'),
    PopupChangeEmails: () => import('./components/PopupChangeEmails'),
    PopupDealerDiscount: () => import('./components/PopupDealerDiscount'),
    PopupDealerDelete: () => import('./components/PopupDealerDelete'),
  },

  data: () => ({
    dealers: [],
    filters: {
      manager: null,
      town: null,
      query: '',
    },

    sortList: [
      {
        name: 'default',
        values: ['asc', 'desc'],
        value: 'asc',
      },
      {
        name: 'name',
        values: ['asc', 'desc'],
        value: 'asc',
      },
      {
        name: 'manager',
        values: ['asc', 'desc'],
        value: 'asc',
      },
      {
        name: 'town',
        values: ['asc', 'desc'],
        value: 'asc',
      },
      {
        name: 'subDealer',
        values: ['asc', 'desc'],
        value: 'asc',
      },
    ],

    sort: {
      name: 'default',
      values: ['asc', 'desc'],
      value: 'asc',
    },
    application: false,
    popupEdit: false,
    dealerData: {
      info: null,
      save_and_approve: 0,
    },
    selectOrders: [],
    popupChangeManagerOrder: null,
    popupChangeManagerOrders: [],
    isPopupChangeEmails: false,
    isPopupDealerDiscount: false,
    popupDealerDiscountItem: null,
    popupDealerDelete: null,
  }),

  metaInfo() {
    return {
      title: `Дилеры - Личный кабинет дилера - ${this.getDealer.name}`,
    };
  },

  computed: {
    ...mapState({
      notApprovedDealers: (state) => state.account.dealers.not_approved_dealers,
      configAccess: (state) => state.user.configAccess,
    }),

    ...mapGetters('user', ['getDealer']),
    ...mapGetters('account', ['getEmployees', 'getDealers']),

    isPopupChangeManager() {
      if (this.popupChangeManagerOrder) {
        return true;
      }

      return this.popupChangeManagerOrders.length > 0;
    },

    dealersSort() {
      const sort = this.sort;
      const list = this.dealers || [];
      return list.sort((a, b) => {
        const isAsc = sort.value === 'asc';
        if (sort.name === 'name') {
          if (isAsc) {
            return a.name?.localeCompare(b.name);
          }
          return b.name?.localeCompare(a.name);
        }

        if (sort.name === 'manager') {
          const aManager = this.employeesObj[a?.parent_dealer_employee_id]?.name || '';
          const bManager = this.employeesObj[b?.parent_dealer_employee_id]?.name || '';

          if (isAsc) {
            return aManager?.localeCompare(bManager);
          }

          return bManager?.localeCompare(aManager);
        }

        if (sort.name === 'town') {
          if (isAsc) {
            return a.town?.toLowerCase().localeCompare(b.town?.toLowerCase());
          }

          return b.town?.toLowerCase().localeCompare(a.town?.toLowerCase());
        }

        if (sort.name === 'subDealer') {
          if (isAsc) {
            return a.sub_dealers_count - b.sub_dealers_count;
          }

          return b.sub_dealers_count - a.sub_dealers_count;
        }

        if (sort.name === 'default') {
          if (isAsc) {
            return a.index - b.index;
          }
        }

        return b.index - a.index;
      });
    },

    employeesObj() {
      const obj = this.getEmployees.reduce((acc, value) => ({ ...acc, [value.id]: value }), {});

      return obj;
    },

    cityOptions() {
      const list = this.dealersSort;

      const towns = [...new Set(list.map(({ town = '' }) => town?.toLowerCase()).filter(Boolean))]
        .sort()
        .map((name, index) => ({
          id: index,
          name: name.replace(name[0], name[0].toUpperCase()),
        }));

      return towns;
    },

    managerOptions() {
      const list = this.dealersSort;

      const managers = [
        ...new Set(
          list
            .map(({ parent_dealer_employee_id = '' }) => parent_dealer_employee_id)
            .filter(Boolean),
        ),
      ]
        .map((keyId) => this.employeesObj[keyId])
        .filter(Boolean);

      return managers;
    },
  },

  methods: {
    ...mapActions('account/dealers', ['setNotApprovedDealers']),

    ...mapActions('account', ['pullEmployees']),

    popupDealerDeleteSuccess() {
      this.fetchDealers();
    },

    popupDealerDeleteOpen(item) {
      this.popupDealerDelete = item;
    },

    popupDealerDeleteClose() {
      this.popupDealerDelete = null;
    },

    successEdit() {
      this.fetchDealers();
    },

    updateSubDealers() {
      this.fetchDealers();
    },

    popupCloseSave() {
      this.selectOrders = [];
      this.fetchDealers();
    },

    updateSort(key = '') {
      const currentSort = this.sortList.find(({ name }) => name === key);

      if (!currentSort) {
        return;
      }

      if (this.sort.name === currentSort.name) {
        this.sort = {
          ...this.sort,
          value: this.sort.values.find((item) => item !== this.sort.value),
        };
      } else {
        this.sort = currentSort;
      }
    },

    setUrlQueryFilters() {
      const filters = this.filters;

      this.$nextTick(() => {
        const query = {
          ...(filters?.manager && {
            manager: filters.manager.id,
          }),
          ...(filters?.town?.name && {
            town: filters.town.name,
          }),
          ...(filters?.query && {
            query: filters.query,
          }),
        };

        this.$router.push({
          name: this.$route.name,
          query,
        });
      });
    },

    updateFilter(newFilters = {}) {
      for (const key in newFilters) {
        this.filters[key] = newFilters[key];
      }
      this.setUrlQueryFilters();

      this.$nextTick(() => {
        this.fetchDealers();
      });
    },

    clearFilters() {
      for (const key in this.filters) {
        this.filters[key] = null;
      }
      this.setUrlQueryFilters();
      this.$nextTick(() => {
        this.fetchDealers();
      });
    },

    setDiscounts() {
      this.isPopupDealerDiscount = true;
    },

    clickDiscount(item) {
      this.popupDealerDiscountItem = item;
      this.isPopupDealerDiscount = true;
    },

    changeManager(item) {
      this.popupChangeManagerOrder = item;
    },

    changeManagerOrders() {
      this.popupChangeManagerOrders = [...this.selectOrders];
    },

    changeEmails() {
      this.isPopupChangeEmails = true;
    },

    changeEmailsClose() {
      this.isPopupChangeEmails = false;
    },

    popupChangeManagerClose() {
      this.popupChangeManagerOrder = null;
      this.popupChangeManagerOrders = [];
    },

    popupDealerDiscountClose() {
      this.popupDealerDiscountItem = null;
      this.isPopupDealerDiscount = false;
    },

    getIsSelectedOrdersItem(item) {
      return this.selectOrders.includes(item.uuid);
    },

    updateSelectOrders(item) {
      if (this.getIsSelectedOrdersItem(item)) {
        this.selectOrders = this.selectOrders.filter((id) => id !== item.uuid);
      } else {
        this.selectOrders = [...this.selectOrders, item.uuid];
      }
    },

    updateAllSelected() {
      if (this.selectOrders.length === this.dealersSort.length) {
        this.selectOrders = [];
      } else {
        this.selectOrders = this.dealersSort.map(({ uuid }) => uuid);
      }
    },

    dealerDeclineToggle() {
      this.application = !this.application;
    },

    dealersCount(type) {
      const dealers = this.dealersSort;
      let result = 0;
      for (const i in dealers) {
        result += dealers[i][type];
      }
      return result;
    },

    pullNotApprovedDealers() {
      this.setNotApprovedDealers();
    },

    popupEditToggle() {
      this.popupEdit = !this.popupEdit;
    },

    async fetchDealers(initFilters = null) {
      if (!initFilters) {
        this.togglePreload();
      }
      try {
        const params =
          initFilters ??
          Object.entries(this.filters).reduce(
            (acc, [key, value]) =>
              value
                ? {
                    ...acc,
                    [key]: key === 'town' ? value.name : value?.id ? value.id : value,
                  }
                : acc,
            {},
          );

        const res = await this.$api.methods.dealers.getSubDealers.get({
          filters: params,
        });

        if (res.data) {
          const list = Object.freeze(res.data);
          this.dealers = list.reduce(
            (acc, item, index) => [...acc, { ...item, index: index + 1 }],
            [],
          );
        }

        if (this.selectOrders.length) {
          this.selectOrders = this.selectOrders.filter(({ uuid = '' }) =>
            this.dealers.includes(uuid),
          );
        }
      } catch (err) {
        console.error(err);
      } finally {
        if (!initFilters) {
          this.togglePreload();
        }
      }
    },

    async initPage() {
      try {
        this.togglePreload();
        await Promise.all([
          this.pullEmployees(),
          this.fetchDealers(this.$route.query),
          this.setNotApprovedDealers(),
        ]);
      } catch {
        this.$danger('Ошибка в получении данных');
      } finally {
        this.$nextTick(() => {
          const urlQuery = this.$route.query;
          if (urlQuery?.manager) {
            const managerFind = this.getEmployees.find(
              ({ id = '' }) => String(id) === String(urlQuery.manager),
            );

            if (managerFind) {
              this.filters.manager = managerFind;
            }
          }

          if (urlQuery.town) {
            const townFind = this.cityOptions.find(
              ({ name = '' }) => String(name) === String(urlQuery.town),
            );

            if (townFind) {
              this.filters.town = townFind;
            }
          }

          if (urlQuery.query) {
            this.filters.query = urlQuery.query;
          }

          this.togglePreload();
        });
      }
    },
  },

  mounted() {
    this.initPage();
  },
};
</script>

<style scoped lang="scss">
.dealers {
  padding-bottom: 70px;

  @media (max-width: $desktop) {
    padding-bottom: 20px;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    position: fixed;
    z-index: 120;
    left: 50%;
    transform: translateX(-50%);
    top: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: 53px;
    margin: 0;

    @media (max-width: $desktop) {
      position: static;
      height: auto;
      transform: translateX(0);
      margin-bottom: 11px;
    }
  }

  &__head {
    margin-bottom: 12px;
    position: relative;
    padding-left: 15px;
    padding-right: 15px;

    @include maxMobile {
      display: block;
      margin-bottom: 8px;
      padding: 0;
    }
  }

  &__caption {
    font-size: 14px;
    line-height: 18px;
    color: #979797;
    margin-bottom: 3px;
  }

  &__result {
    font-size: 12px;
    line-height: 15px;
    padding-left: 15px;
    padding-right: 15px;
    margin-top: 20px;

    span {
      font-weight: bold;
    }

    @include maxMobile {
      padding: 0;
    }
  }
}
</style>
